import React from 'react';

import { Rectangle, SkeletonContainer } from '../../../LoadingSkeletons';

import { BodyStyles } from './Body.styles';
import type { FacebookStoryComponentsProps } from './types';

export function Body(props: FacebookStoryComponentsProps): React.JSX.Element {
	const { size, loading, previewImageUrl, retryState } = props;

	const styles = BodyStyles({ size });

	// Disable animation when in failed retry state (static background for better contrast)
	const shouldAnimate = loading && retryState !== 'failed';

	if (loading) {
		if (size === 'xsmall') {
			return (
				<SkeletonContainer loading={shouldAnimate} className="h-full w-full" data-testid="empty-container">
					<Rectangle className="h-full w-full" />
				</SkeletonContainer>
			);
		}
		return (
			<SkeletonContainer
				loading={shouldAnimate}
				className={styles}
				shapeColorClassName="bg-icon-weak"
				data-testid="empty-container"
			>
				<Rectangle className="h-full w-full" />
			</SkeletonContainer>
		);
	}

	return <img data-testid="body-image" className={styles} src={previewImageUrl} alt="" aria-hidden />;
}
